/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `loop` - 루프
 * `pingpong` - 핑퐁
 */
export type LoopModeEnum = (typeof LoopModeEnum)[keyof typeof LoopModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoopModeEnum = {
  loop: "loop",
  pingpong: "pingpong",
} as const;
